import { LoadingSpinner } from "@/components/atoms";

export function PageLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-page text-white">
      <LoadingSpinner size="xl" color="primary" />
      <p className="text-sm text-white/60">{label}</p>
    </div>
  );
}
